var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderCirclePetroprix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B363B",
    d: "M29.5 58.95A29.47 29.47 0 0 1 27.88.05L30.04 0c5.1.1 10.08 1.51 14.47 4.11a7.58 7.58 0 0 1-8.63 3.43c-1.9-.56-3.86-.87-5.84-.92l-1.92.04a22.62 22.62 0 0 0-16.17 8.16 22.87 22.87 0 0 0 17.51 37.52H30a22.86 22.86 0 0 0 22.23-25.42A7.54 7.54 0 0 1 57.07 19a29.47 29.47 0 0 1-26.93 39.95h-.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB0B27",
    d: "M57.32 12.17a9.17 9.17 0 0 1-7.54-7.54.64.64 0 0 0-1.25 0 9.17 9.17 0 0 1-7.54 7.54.63.63 0 0 0-.4 1.03c.1.12.24.2.39.22a9.17 9.17 0 0 1 7.54 7.54.62.62 0 0 0 .62.54.64.64 0 0 0 .63-.53 9.16 9.16 0 0 1 7.54-7.54.64.64 0 0 0 0-1.26h.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderCirclePetroprix);
export default __webpack_public_path__ + "static/media/loader-circle-petroprix.66d04c326d7bc41447e775b273a8e358.svg";
export { ForwardRef as ReactComponent };